import {useEffect, useState} from 'react';

export const useIsAndroidWebView = () => {
  const [isAndroidWebView, setIsAndroidWebView] = useState(false);
  useEffect(() => {
    const ua = window.navigator.userAgent;
    setIsAndroidWebView(ua.indexOf('Gaishishukatsu Android App') > 0);
  }, []);
  return isAndroidWebView;
};
